module.exports = [{"value":"int","label":"int (整数型)"},{"value":"float","label":"float (单精度浮点型)"},{"value":"double","label":"double (双精度浮点型)"},{"value":"enum","label":"enum (枚举型)"},{"value":"bool","label":"bool (布尔型)"},{"value":"text","label":"text (字符串)"},{"value":"date","label":"date (时间)"}]


//////////////////
// WEBPACK FOOTER
// ./src/assets/js/dataType.json
// module id = CzPe
// module chunks = 3